export default __webpack_public_path__ + "static/media/succulent1-big.5199e0e0.jpg";